import React from 'react';
import background from '../../assets/population.jpg';
import styled from 'styled-components';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, 
} from 'recharts';

const Container = styled.div`
  display: flex;
  flex-direction:row;
  justify-content:space-between;
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 9px;
  background-color: rgba(0,0,0,1);
    box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  overflow:hidden;
  position: relative;

  @media (max-width: 768px) {
    height:350px;

  }

`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction:column;
  height: auto;
  float:bottom;
  margin-left:0px;
`;

const Right = styled.div`
  display: flex;
  height: auto;
  justify-content: center;
  z-index:0;
  width:50%;
  @media (max-width: 768px) {
    margin-right:40px;
    margin-top:15px;
    justify-content:flex-start;
  }
`;

const Bg = styled.img`
 
  position: absolute;
  height:100%;
  justify-content: space-around;
  align-self:flex-end;
  opacity:80%;
    
`;

const Inner01 = styled.div`
  display: flex;
  flex-direction:column;
  flex-start;
  width: 50%;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;
  position:absolute;
  z-index:1;

`;

const Customtip = styled.div`
  background-color: rgba(0,0,0,0.5);
  border-radius:3px;
  display:flex;

`;

const Labeltip = styled.span`
  font-size: 0.9rem;
  color: #ffffff;
  line-height: 1.3;
  letter-spacing: 1px;
  justify-content:space-around;
  align-self:center;
  margin:10px;
`;

const Tag = styled.span`
  font-size: 0.9rem;
  color: #13F9B2;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
  justify-content:left;
  pointer-events:none;
`;

const Description = styled.p`
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.4em;
  letter-spacing: .6px;  
`;

const Paragraph = styled.p`
  font-family:roboto;
  font-size: 0.9rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  z-index:5;
`;

const data = [
  {
    name: '1900', uv: 4000, popl: 1.66, amt: 2400,
  }, 
  {
    name: '1910', uv: 4000, popl: 1.75, amt: 2400,
  },
  {
    name: '1920', uv: 4000, popl: 1.96, amt: 2400,
  },
  {
    name: '1930', uv: 4000, popl: 2.14, amt: 2400,
  },
  {
    name: '1940', uv: 4000, popl: 2.34, amt: 2400,
  },
  {
    name: '1950', uv: 4000, popl: 2.52, amt: 2400,
  },
  {
    name: '1960', uv: 3000, popl: 3.01, amt: 2210,
  },
  {
    name: '1970', uv: 2000, popl: 3.68, amt: 2290,
  },
  {
    name: '1980', uv: 2780, popl: 4.44, amt: 2000,
  },
  {
    name: '1990', uv: 1890, popl: 5.31, amt: 2181,
  },
  {
    name: '2000', uv: 2390, popl: 6.12, amt: 2500,
  },
  {
    name: '2010', uv: 3490, popl: 6.93, amt: 2100,
  },
    {
    name: '2020', uv: 3490, popl: 7.81, amt: 2100,
  },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <Customtip>
        <Labeltip>{"Human pop. ↑"} : {payload[0].value}{"Billion"} </Labeltip>
      </Customtip>
    );
  }

  return null;
};

class InfoPopulation extends React.Component {
  render () { 
   return(

  <Container>
  <Left>
     <Inner01>
        <Tag>LAND</Tag>
        <Description>Population</Description>
        <Paragraph>Our increasing global population and industrial expansion are accelerating the depletion of precious resources.</Paragraph>             
        
       

   <LineChart width={300} height={150} data={data}>
        <Line type='monotone' dataKey='popl' stroke="url(#colorUv)" strokeWidth={3} dot={false}/>
        <XAxis dataKey="name" tick={{fontSize: 12, fill: '#fff'}}stroke="#ed146f"/>
        <YAxis type="number" tick={false}  width={0} domain={[0, 8]}/>
        
        <Tooltip content={<CustomTooltip />} />
        
        <defs>
        <linearGradient id="colorUv" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#13F9B2" />
          <stop offset="100%" stopColor="#ffd900" />
        </linearGradient>
      </defs>
        </LineChart>

        </Inner01>
    </Left>

    <Right>
    <Bg src = {background}/>
   </Right>
   
  </Container>
  
  );
 }
}   

export default InfoPopulation;
